import axiosInstance from "./AxiosInstance";

// Valorcar Expedições — endpoints documentados em
// api/Controllers/ValorcarController.js.

export function getValorcarCategories() {
  return axiosInstance.get(`/valorcar/categories`);
}

export function getValorcarSettings() {
  return axiosInstance.get(`/valorcar/settings`);
}

export function toggleValorcarSettings(enabled) {
  return axiosInstance.post(`/valorcar/settings/toggle`, {
    enabled: enabled ? 1 : 0,
  });
}

export function listValorcarMovements(filters = {}) {
  return axiosInstance.post(`/valorcar/movements/list`, filters);
}

export function fillValorcarMovement(id, lines, notes) {
  return axiosInstance.post(`/valorcar/movements/${id}/lines`, {
    lines,
    notes,
  });
}

export function dismissValorcarMovement(id) {
  return axiosInstance.post(`/valorcar/movements/${id}/dismiss`);
}

export function getValorcarReport({
  year,
  period = "month",
  category_id,
  source,
} = {}) {
  return axiosInstance.get(`/valorcar/report`, {
    params: { year, period, category_id, source },
  });
}
